export default {
  name: 'WarningTriangleIcon',
  props: {
    width: {
      type: Number,
      default: 45
    },
    height: {
      type: Number,
      default: 45
    },
    positionCSS: {
      type: String,
      default: ''
    }
  },

  setup(props){
    return props
  }
}
